import Vue from "vue";
import api from '@/api/apiList.js'
import baseUrl from '@/api/baseUrl.js';
import Vuex from "vuex";
import axios from 'axios';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    register: {},
    paymentStatus: false,
    schools: [],
    provinces: [], // 省
    resumeStatus: {
      '': '全部',
      'apply': '待处理',
      // 'no_audit': '待处理',
      'pass': '通过',
      'no_pass': '不通过',
      'interes': '感兴趣',
      'no_call': '未接通',
      'dead_number': '空号',
      // 'apply': '待沟通',
      // 'contact': '已沟通',
      // 'no_interest': '暂无意向',
      // 'no_match': '不合适',
      // 'auditon': '已面试',
      // 'employed': '录用',
      // 'entry': '入职'
    },
    jobTypes: [
      { label: '企校云', value: 'qxiaoyun' },
      { label: '双选会', value: 'sxh' },
      { label: '实习申请', value: 'sxsq' },
      { label: '置顶', value: 'top' },
    ],
    resumesNum: 0,
    platformResumesNum: 0,
    schooldResumesNum: 0,
    signResumesNum: 0,
    salaryList: [],
    foodBedList: [],
    educations: [],
    trades: []
  },
  getters: {
    getSchools(state) {
      return state.schools
    }
  },
  mutations: {
    // 注册
    reg(state, form) {
      state.register = form;
    },
    setSchools(state, payload) {
      state.schools = payload
    },
    setProvinces(state, payload) {
      state.provinces = payload
    },
  },
  actions: {
    async getSchools(context) {
      let res = await api.school.getSchool(1, 50)
      if (res.code === 0) {
        context.commit('setSchools', res.data.items)
      }
    },
    async getProvinces(context) {
      let res = await api.common.getXixunProvince()
      if (res.code === 0) {
        context.commit('setProvinces', res.data)
      }
    },
    async getSalaryList(context) {
      let res = await api.common.getSalaryList()
      if (res.code === 0 || res.code === 2000) {
        context.state.salaryList = res.data
      }
    },
    async getFoodBedList(context) {
      let res = await api.common.getTypeList("food_bed");
      if (res.code === 0) {
        context.state.foodBedList = res.data
      }
    },
    async getEducations(context) {
      let education = await api.common.getEducationList();
      if (education.code === 0) {
        context.state.educations = education.data;
      }
    },
    async getTrades(context) {
      let trade = await api.common.getTrade();
      if (trade.code === 0) {
        context.state.trades = trade.data;
      }
    },
    async getResumesNum(context) {
      let { data } = await axios.get(
        `${baseUrl}api/enterprise/job_apply/count`,
        { withCredentials: true }
      )
      if (data.code === 0) {
        context.state.platformResumesNum = data.data.faxian;
        context.state.schooldResumesNum = data.data.plat;
        context.state.signResumesNum = data.data.sign;
      }
    }
  }
});